const game = () => {
  const nameStore = {
    'aion': {
      'en': 'aion',
      'ko': '아이온'
    },
    'lineage': {
      'en': 'lineage',
      'ko': '리니지'
    },
    'lineage2': {
      'en': 'lineage2',
      'ko': '리니지2'
    },
    'bns': {
      'en': 'bns',
      'ko': '블소'
    },
    'lovebeat': {
      'en': 'lovebeat',
      'ko': '러브비트'
    },
    'event': {
      'en': 'plaync',
      'ko': '플레이엔씨'
    }
  };

  return nameStore[location.hostname.split('.plaync.com')[0]];
};

export default game;
